module.exports = __webpack_public_path__ + "static/media/icono_comediante.c8647baf.svg";